/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import LoadingIndicator from '../loadingIndicator/LoadingIndicator';
import './BorderedButton.css';

class BorderedButton extends Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.onLink = this.onLink.bind(this);
  }

  onClick() {
    const { onClick, beforeAction } = this.props;

    if (beforeAction) {
      beforeAction();
    }

    onClick();
  }

  onLink() {
    const { beforeAction } = this.props;

    if (beforeAction) {
      beforeAction();
    }

    return true;
  }

  renderButton() {
    const {
      title,
      monoMode,
      darkMonoMode,
      redirect,
      href,
      id,
      loading,
    } = this.props;

    let classesName = 'bordered-button';

    if (monoMode) {
      classesName += ' mono-mode';
    } else if (darkMonoMode) {
      classesName += ' dark-mono-mode';
    } else {
      classesName += ' gradient-mode';
    }

    if (loading) {
      classesName += ' right-space';
    }

    if (redirect) {
      return (
        <Link
          className={classesName}
          to={redirect}
          id={id}
          onClick={this.onLink}
        >
          <span>{title}</span>
        </Link>
      );
    }

    if (href) {
      return (
        <a
          className={classesName}
          href={href}
          id={id}
          target="_blank"
          rel="noopener noreferrer"
          onClick={this.onLink}
        >
          <span>{title}</span>
        </a>
      );
    }

    return (
      <button
        className={classesName}
        type="button"
        onClick={this.onClick}
        id={id}
        disabled={loading}
      >
        <span>{title}</span>
      </button>
    );
  }

  render() {
    const { loading, centered } = this.props;

    let containerClasses = 'bordered-button-container';
    if (centered) {
      containerClasses += ' centered';
    }

    return (
      <div className={containerClasses}>
        {this.renderButton()}
        <LoadingIndicator
          loading={loading}
          small
        />
      </div>
    );
  }
}

BorderedButton.propTypes = {
  title: PropTypes.string.isRequired,
  monoMode: PropTypes.bool,
  darkMonoMode: PropTypes.bool,
  redirect: (props, propName, componentName) => {
    const { redirect, onClick, href } = props;
    if (!redirect && !onClick && !href) {
      return new Error(`One of props 'redirect' or 'onClick' or 'href' was not specified in '${componentName}'.`);
    } if (redirect && (typeof redirect !== 'string')) {
      return new Error("'redirect' prop must be a string");
    }
    return null;
  },
  onClick: (props, propName, componentName) => {
    const { redirect, onClick, href } = props;
    if (!redirect && !onClick && !href) {
      return new Error(`One of props 'redirect' or 'onClick' or 'href' was not specified in '${componentName}'.`);
    } if (onClick && (typeof onClick !== 'function')) {
      return new Error("'onClick' prop must be a function");
    }
    return null;
  },
  href: (props, propName, componentName) => {
    const { redirect, onClick, href } = props;
    if (!redirect && !onClick && !href) {
      return new Error(`One of props 'redirect' or 'onClick' or 'href' was not specified in '${componentName}'.`);
    } if (href && (typeof href !== 'string')) {
      return new Error("'href' prop must be a string");
    }
    return null;
  },
  beforeAction: PropTypes.func,
  id: PropTypes.string,
  loading: PropTypes.bool,
  centered: PropTypes.bool,
};

BorderedButton.defaultProps = {
  darkMonoMode: false,
  monoMode: false,
  beforeAction: null,
  id: '',
  loading: false,
  centered: false,
};

export default BorderedButton;
